import { NavigationStep } from './forward-history';

/**
 * Whether there is a page behind this one in the session's history.
 *
 * The same reason as ForwardHistory: the browser knows and will not say. A
 * cold start, a deep link and a tap on a notification all land on the first
 * entry, where Location.back() does nothing at all, so the back gesture has to
 * know before it promises anything.
 *
 * WHAT MOVES IT
 *
 *   a new page pushed      one more entry, unless it replaced the current one
 *   a step back            one fewer, never below the page we are on
 *   a step forward         one more
 *
 * Counted on the navigations that ended, not those that started: a guard that
 * redirects cancels the first and runs a second, and only one entry is made.
 */
export class BackHistory {
  /** Entries up to and including the current page. Zero before the first. */
  private entries = 0;

  get canGoBack(): boolean {
    return this.entries > 1;
  }

  record(step: NavigationStep, replacedTheCurrentPage = false): void {
    if (step === 'back') {
      this.entries = Math.max(1, this.entries - 1);
      return;
    }
    if (step === 'forward') {
      this.entries += 1;
      return;
    }
    if (replacedTheCurrentPage && this.entries > 0) {
      return;
    }
    this.entries += 1;
  }
}
